import { render, staticRenderFns } from "./AppChat.vue?vue&type=template&id=95a819f2&scoped=true"
import script from "./AppChat.vue?vue&type=script&lang=js"
export * from "./AppChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a819f2",
  null
  
)

export default component.exports